import { Directive, TemplateRef } from '@angular/core';
import {
  SgAutoCompleteSelect2OptionContext,
  SgAutoCompleteSelect2TriggerContext,
} from './sg-auto-complete-select-2.models';

/**
 * Directive for custom option templates in sg-auto-complete-select-2.
 *
 * @example
 * ```html
 * <sg-auto-complete-select-2 [options]="items">
 *   <ng-template sgAutoCompleteSelect2Option let-ctx>
 *     <span>{{ ctx.option.name }}</span>
 *   </ng-template>
 * </sg-auto-complete-select-2>
 * ```
 */
@Directive({
  selector: '[sgAutoCompleteSelect2Option]',
  standalone: false,
})
export class SgAutoCompleteSelect2OptionDirective {
  constructor(public templateRef: TemplateRef<SgAutoCompleteSelect2OptionContext<any>>) {}

  static ngTemplateContextGuard(
    _dir: SgAutoCompleteSelect2OptionDirective,
    ctx: unknown
  ): ctx is SgAutoCompleteSelect2OptionContext<any> {
    return true;
  }
}

/**
 * Directive for custom trigger templates in sg-auto-complete-select-2.
 *
 * @example
 * ```html
 * <sg-auto-complete-select-2 [options]="items">
 *   <ng-template sgAutoCompleteSelect2Trigger let-value>
 *     <span>Custom: {{ value }}</span>
 *   </ng-template>
 * </sg-auto-complete-select-2>
 * ```
 */
@Directive({
  selector: '[sgAutoCompleteSelect2Trigger]',
  standalone: false,
})
export class SgAutoCompleteSelect2TriggerDirective {
  constructor(public templateRef: TemplateRef<SgAutoCompleteSelect2TriggerContext<any>>) {}

  static ngTemplateContextGuard(
    _dir: SgAutoCompleteSelect2TriggerDirective,
    ctx: unknown
  ): ctx is SgAutoCompleteSelect2TriggerContext<any> {
    return true;
  }
}

/**
 * Directive for async loading template in sg-auto-complete-select-2.
 * Used to show loading indicators when fetching more options.
 *
 * @example
 * ```html
 * <sg-auto-complete-select-2 [options]="items">
 *   <ng-template sgAutoCompleteSelect2AsyncTemplate>
 *     <mat-progress-bar mode="indeterminate"></mat-progress-bar>
 *   </ng-template>
 * </sg-auto-complete-select-2>
 * ```
 */
@Directive({
  selector: '[sgAutoCompleteSelect2AsyncTemplate]',
  standalone: false,
})
export class SgAutoCompleteSelect2AsyncTemplateDirective {
  constructor(public templateRef: TemplateRef<void>) {}
}
